import { CheckBox } from '@idexx-laboratories/spot-react';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useStore } from '../../hooks/use-store';
import './DisconnectPracticeModalContent.scss';

interface DisconnectPracticeModalContentProps {
  practiceName: string;
}

const DisconnectPracticeModalContent = observer((props: DisconnectPracticeModalContentProps) => {
  const { globalModalStore } = useStore();
  const modalState = globalModalStore.globalModalState;

  useEffect(() => {
    runInAction(() => (modalState.okDisabled = true));
  }, [modalState]);

  return (
    <div className='disconnect-practice-content_container'>
      <p>You have selected to disconnect the Trupanion integration for {props.practiceName}</p>
      <CheckBox
        id='disconnect-practice-cb'
        label='Do you wish to continue?'
        size='small'
        checked={!modalState.okDisabled}
        aria-label='disconnect-practice'
        onChange={e => runInAction(() => (modalState.okDisabled = !e.target.checked))}
        data-testid='disconnect-practice-cb'
      />
    </div>
  );
});

export default DisconnectPracticeModalContent;
